export enum OrderStatusEnum {
  NEW = 1,
  IN_PROGRESS = 2,
  READY = 3,
  DELIVERED = 4,
  OUT_FOR_DELIVERY = 5,
  CANCELLED = 6,
  PENDING = 7,
  FAILED = 8,
  NEW_PREORDER = 9,
  CANCELLED_FOR_REOPEN = 10,
  IN_TRANSIT = 11
}

/**
 * Keep in sync with `OrderStatusEnum` and values in `orderstatus` table in the Database.
 */
export enum OrderStatusNameValueEnum {
  NEW = 'New',
  IN_PROGRESS = 'InProgress',
  READY = 'Ready',
  DELIVERED = 'Delivered',
  OUT_FOR_DELIVERY = 'Out-For-Delivery',
  CANCELLED = 'Cancelled',
  PENDING = 'Pending',
  FAILED = 'Failed',
  NEW_PREORDER = 'New-Preorder',
  CANCELLED_FOR_REOPEN = 'Cancelled-For-Reopen',
  IN_TRANSIT = 'InTransit'
}

export enum OrderStatusDisplayNameValueEnum {
  NEW = 'New',
  IN_PROGRESS = 'In Progress',
  READY = 'Ready',
  DELIVERED = 'Delivered',
  OUT_FOR_DELIVERY = 'Out For Delivery',
  CANCELLED = 'Cancelled',
  PENDING = 'Pending',
  FAILED = 'Failed',
  NEW_PREORDER = 'New Preorder',
  CANCELLED_FOR_REOPEN = 'Cancelled For Reopen',
  IN_TRANSIT = 'In Transit'
}